import { render, staticRenderFns } from "./CategoryVideo.vue?vue&type=template&id=0151e0af&"
import script from "./CategoryVideo.js?vue&type=script&lang=js&"
export * from "./CategoryVideo.js?vue&type=script&lang=js&"
import style0 from "./CategoryVideo.scss?vue&type=style&index=0&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports